import { createFileRoute } from '@tanstack/react-router';
import { AnnouncementsPage } from '../../features/community';

export const Route = createFileRoute('/portal/announcements')({ component: AnnouncementsPage });
